import "babel-polyfill";
import React from "react";
import Modal from "react-modal";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/lib/integration/react";
import store from "./config/createStore";

import "./index.css";
import App from "./App";
import registerServiceWorker from "./registerServiceWorker";

let persistor = persistStore(store);

const app = (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </PersistGate>
  </Provider>
);
Modal.setAppElement(document.getElementById("root"));

ReactDOM.render(app, document.getElementById("root"));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js